import React from 'react';
import PropTypes from 'prop-types';

const Pagination = ({ activeIndex }) => (
  <ul className="progress">
    {[...Array(4).keys()].map((item) => <li key={item} className={item === activeIndex ? 'highlight' : ''} />)}
  </ul>
);

Pagination.propTypes = {
  activeIndex: PropTypes.number,
};

Pagination.defaultProps = {
  activeIndex: 0,
};

export default Pagination;
